import { useEffect } from "react";

const Page: React.FC<any> = (props: any) => {
  useEffect(() => {
    document.title = props.title || "";
  }, [props.title]);
  return props.children;
};

export default Page;
